import { RouteRecordRaw } from 'vue-router';
import { configuratiebeheerder, systeembeheerder } from '@/core/security/roleTypes';
import Configuration from './Configuration.vue';
import EntityModelDetail from './entity-model/EntityModelDetail.vue';
import EntityModelCreate from './entity-model/EntityModelCreate.vue';
import EntityModelDependencies from './entity-model/EntityModelDependencies.vue';
import DeliveryProcessDefinitionDetail from './delivery-process-definition/DeliveryProcessDefinitionDetail.vue';
import DeliveryProcessDefinitionDependencies from './delivery-process-definition/DeliveryProcessDefinitionDependencies.vue';
import DeliveryProcessDefinitionGeckoSync from './delivery-process-definition/DeliveryProcessDefinitionGeckoSync.vue';
import DeliveryProcessDefinitionCreate from './delivery-process-definition/DeliveryProcessDefinitionCreate.vue';
import ProductProcessDefinitionDetail from './product-process-definition/ProductProcessDefinitionDetail.vue';
import ProductProcessDefinitionCreate from './product-process-definition/ProductProcessDefinitionCreate.vue';
import ProductProcessDefinitionDependencies from './product-process-definition/ProductProcessDefinitionDependencies.vue';
import OrganisationDetail from './organisation/OrganisationDetail.vue';
import OrganisationCreate from './organisation/OrganisationCreate.vue';
import ProductGroupDetail from './product-group/ProductGroupDetail.vue';
import ProductGroupCreate from './product-group/ProductGroupCreate.vue';
import ProcessTriggerDetail from './process-trigger/ProcessTriggerDetail.vue';
import ProcessTriggerCreate from './process-trigger/ProcessTriggerCreate.vue';

export const configurationRoutes: RouteRecordRaw = {
    path: '/configuration',
    meta: {
        hasRoles: [configuratiebeheerder, systeembeheerder],
        feature: 'configuration'
    },
    children: [
        {
            path: '',
            name: 'configuration',
            component: Configuration,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'entitymodel/:id',
            name: 'entitymodel.detail',
            component: EntityModelDetail,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'entitymodel/:id/dependencies',
            name: 'entitymodel.detail.dependencies',
            component: EntityModelDependencies,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'entitymodel/create',
            name: 'entitymodel.create',
            component: EntityModelCreate,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'deliveryprocessdefinition/:id',
            name: 'deliveryprocessdefinition.detail',
            component: DeliveryProcessDefinitionDetail,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'deliveryprocessdefinition/:id/dependencies',
            name: 'deliveryprocessdefinition.detail.dependencies',
            component: DeliveryProcessDefinitionDependencies,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'deliveryprocessdefinition/:id/qualitycheck',
            name: 'deliveryprocessdefinition.detail.qualitycheck',
            component: DeliveryProcessDefinitionGeckoSync,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'deliveryprocessdefinition/create',
            name: 'deliveryprocessdefinition.create',
            component: DeliveryProcessDefinitionCreate,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'productprocessdefinition/:id',
            name: 'productprocessdefinition.detail',
            component: ProductProcessDefinitionDetail,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'productprocessdefinition/:id/dependencies',
            name: 'productprocessdefinition.detail.dependencies',
            component: ProductProcessDefinitionDependencies,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'productprocessdefinition/create',
            name: 'productprocessdefinition.create',
            component: ProductProcessDefinitionCreate,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'organisation/:id',
            name: 'organisation.detail',
            component: OrganisationDetail,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'organisation/create',
            name: 'organisation.create',
            component: OrganisationCreate,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'productgroup/:id',
            name: 'productgroup.detail',
            component: ProductGroupDetail,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'productgroup/create',
            name: 'productgroup.create',
            component: ProductGroupCreate,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'processtrigger/:id',
            name: 'processtrigger.detail',
            component: ProcessTriggerDetail,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        },
        {
            path: 'processtrigger/create',
            name: 'processtrigger.create',
            component: ProcessTriggerCreate,
            meta: {
                hasRoles: [configuratiebeheerder, systeembeheerder]
            }
        }
    ]
};
